module.exports = __webpack_public_path__ + "img/spinner-of-dots.957dd891.svg";